import { render, staticRenderFns } from "./ProductSubCategory.vue?vue&type=template&id=bd530148&scoped=true"
import script from "./ProductSubCategory.vue?vue&type=script&lang=js"
export * from "./ProductSubCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductSubCategory.vue?vue&type=style&index=0&id=bd530148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd530148",
  null
  
)

export default component.exports